import { z } from 'zod';

import { TypeLanguages } from '../models/contentful-generated';
import { ContentfulSysSchema } from './contentful-sys.validator';

export const LanguagesEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    fullName: z.string(),
    shortName: z.string()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateLanguagesEntry(data: TypeLanguages) {
  return LanguagesEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateLanguagesEntries(data: TypeLanguages[]) {
  return z.array(LanguagesEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterLanguagesEntries(data: TypeLanguages[]) {
  if (!data) return [];

  return data.reduce((acc: TypeLanguages[], entry) => {
    const validationResult = validateLanguagesEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeLanguages);
    } else {
      console.warn(
        `Validation failed for language entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
